import { render, staticRenderFns } from "./ProjectBeknopt.vue?vue&type=template&id=ed0916b4&"
import script from "./ProjectBeknopt.vue?vue&type=script&lang=js&"
export * from "./ProjectBeknopt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBeknopt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectBeknopt.vue"
export default component.exports